export const reduxKey = '@@collections2';
export const actionKey = '@@COLLECTIONPANEL2';
export const streamId = '@@collections2';
export const COLLECTIONS_PAGE_SIZE = 20;
export const UNDO_TIMEOUT = 5000;
